import { cmpCookie } from "@foundation/cmp-client";
import DependencyLoader from "../DependencyLoader";
import PerformanceMonitor from "../util/monitoring/PerformanceMonitor";
import makeMeasure from "../util/makeMeasure";
import fireEREvt from "../util/eventRecorderClient";
import { OnDvTagReadyCb } from "../type";
import { doubleVerifyInitScript, doubleVerifyScriptUrl } from "./doubleVerifyScript";

export default class DoubleVerifyTracking extends DependencyLoader {

    private _dvScriptUrl: string;

    /**
     * @type {PerformanceMonitor}
     * @private
     */
    _performanceMonitor = new PerformanceMonitor("Sparkle:DoubleVerify");
    _measure = makeMeasure(this._performanceMonitor);

    constructor(dvScriptUrl = doubleVerifyScriptUrl) {
        super();
        this._dvScriptUrl = dvScriptUrl;
    }

    init() {
        if (!cmpCookie.padAllowed()) {
            fireEREvt("ad-double-verify-no-consent");

            return;
        }

        this.loadScript();
    }

    loadScript() {
        fireEREvt("ad-double-verify-load-start");
        // Stub before inject so ad requests queue on dvtag.cmd while pub.js loads
        doubleVerifyInitScript();
        this._measure(
            "loadDoubleVerify",
            () => this.loadScriptDependency(this._dvScriptUrl).then(() => {
                fireEREvt("ad-double-verify-load-end");
            })
        ).catch((e) => {
            console.error(`Error init doubleVerify Script:  ${ e }`);
        });
    }

    callOnDvTagReady(cb?: OnDvTagReadyCb) {
        if (typeof window.onDvtagReady === "function") {
            try {
                window.onDvtagReady(cb);
            } catch (error) {
                console.error("failed to init onDvtagReady function for double verify");
            }
        } else if (typeof cb === "function") {
            // fallback to call back function
            cb();
        }
    }

    /**
     * each individual GAM requests and refreshes triggers need to be wrapped in DV callback
     * @returns promise
     */
    dvtagReadyPromise() {
        return new Promise<void>((resolve) => {
            this.callOnDvTagReady(resolve);
        });
    }

}
